import { render, staticRenderFns } from "./formations_table.vue?vue&type=template&id=a1fe1d2e&scoped=true&lang=pug&"
import script from "./formations_table.vue?vue&type=script&lang=coffee&"
export * from "./formations_table.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fe1d2e",
  null
  
)

export default component.exports